export default function Agendas() {
  return (
    <div>
      <h1>Agendas</h1>      
    </div>
  );
}
